import { cva, type VariantProps } from '@mentimeter/ragnar-tailwind-config';
import { ragnarTypography } from '@mentimeter/ragnar-typography';

export const sizeVariants = cva([], {
  variants: {
    size: {
      compact: ragnarTypography.ragnarBodyMd,
      large: ragnarTypography.ragnarHeadline4,
    },
  },
  defaultVariants: {
    size: 'large',
  },
});

export const variants = cva([], {
  variants: {
    isActivePath: {
      true: ['text-text'],
      false: ['text-text-weaker'],
    },
    capitalize: {
      true: ['capitalize'],
      false: ['normal-case'],
    },
  },
});

export type BreadcrumbSizeVariantProps = VariantProps<typeof sizeVariants>;
export type BreadcrumbVariantProps = VariantProps<typeof variants>;
